var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mr-0 ml-0 mt-3"},[_c('div',{staticClass:"col-12 nopadding"},[_c('div',{staticClass:"col-12"},[_c('table-data',{attrs:{"races":_vm.tableData}})],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e00cf06","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/race-events/race-calendar-widget/layout/layout.html
// module id = null
// module chunks = 